.blank {
  flex-grow: 1;
}

.horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
}
